require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/_core').Number.isInteger;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/number/is-integer.js
// module id = 71
// module chunks = 0 1